import {pt2px} from '@/utils/converter'
import React from 'react'
import Image from 'next/image'
import 'yet-another-react-lightbox/styles.css'
import {useRouter} from 'next/router'
import next from 'next'

const formatImageUrl = (url: string | undefined) => {
  if (!url) return '/placeholder.png';
  
  // If it's already a full URL, return it
  if (url.startsWith('http')) return url;
  
  // Remove any leading slashes from the path
  const cleanPath = url.replace(/^\/+/, '');
  
  // Construct the CDN URL, ensuring no double slashes
  const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL?.replace(/\/+$/, '') || '';
  return `${cdnUrl}/${cleanPath}`;
};

interface Props {
  pages: any
  pages_predefined_texts: any
  pages_dedication_texts: any
  product: any
  inputDedication: any
  cover_pages_predefined_texts: any
  cover_pages: any
}
export default function NoteBookMobile({
  pages,
  pages_predefined_texts,
  product,
  pages_dedication_texts,
  inputDedication,
  cover_pages,
  cover_pages_predefined_texts,
}: Props) {
  const modified_pages: any = []
  const [imageWidth, setImageWidth] = React.useState(0)
  const [open, setOpen] = React.useState(true)

  const router = useRouter()
  const name =
    router.query.name != undefined ? (router.query.name as string) : ''
  const handleImageLoad = (event: any) => {
    const width = event.target.clientWidth
    setImageWidth(width)
  }
  const slides = [
    {
      type: 'custom-slide',
    },
  ]

  const [page, setPage] = React.useState(0)
  const [scrollPosition, setScrollPosition] = React.useState(0)

  const mobile_book_width =
    (document.getElementById('page-0')?.getBoundingClientRect().width ?? 0) + 25
  React.useEffect(() => {
    // Function to handle the scroll event on the 'mobile-book' div
    const handleScroll = () => {
      // Get the reference to the 'mobile-book' div
      const mobileBookDiv = document.getElementById('note-mobile-book')

      // Update the state with the current scrollLeft position of the 'mobile-book' div
      if (mobileBookDiv) {
        let new_page: number = Math.floor(
          mobileBookDiv.scrollLeft / mobile_book_width,
        )
        if (new_page != 0) {
          new_page *= -1
        }
        setPage(new_page)
        setScrollPosition(mobileBookDiv.scrollLeft)
      }
    }

    // Add event listener for the scroll event on the 'mobile-book' div
    const mobileBookDiv = document.getElementById('note-mobile-book')
    if (mobileBookDiv) {
      mobileBookDiv.addEventListener('scroll', handleScroll)
    }

    // Clean up the event listener when the component unmounts
    return () => {
      if (mobileBookDiv) {
        mobileBookDiv.removeEventListener('scroll', handleScroll)
      }
    }
  }, [mobile_book_width]) // Re-run if page width changes

  function scrollToStart() {
    let new_page: number = 0
    setPage(new_page)
    const next_page = document.getElementById('page-' + new_page)

    if (next_page) {
      next_page.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }

  function scrollToEnd() {
    let new_page: number = modified_pages.length + 1
    setPage(new_page)
    const next_page = document.getElementById('page-' + new_page)

    if (next_page) {
      next_page.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }

  function scrollToNextSnap() {
    let new_page: number = Math.floor(scrollPosition / mobile_book_width)
    if (new_page != 0) {
      new_page *= -1
    }

    setPage(new_page)
    const next_page = document.getElementById('page-' + (new_page - 1))

    if (next_page) {
      setTimeout(() => {
        next_page.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        })
      }, 0)
    }
  }

  function scrollToPrevSnap() {
    let prev_page: number = Math.floor(scrollPosition / mobile_book_width)

    if (prev_page != 0) {
      prev_page *= -1
    }
    console.log(prev_page, prev_page + 1)
    setPage(prev_page)

    const next_page = document.getElementById('page-' + (prev_page + 1))
    if (next_page) {
      console.log(next_page)

      setTimeout(() => {
        next_page.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        })
      }, 0)
    }
  }
  if (pages) {
    //Swap two elements
    for (let index = pages.length - 1; index >= 0; index--) {
      if ((index + 1) % 2 === 0) {
        continue
      }
      modified_pages.push(pages[index + 1], pages[index])
      slides.push(
        {type: 'custom-slide', ...pages[index + 1]},
        {type: 'custom-slide', ...pages[index]},
      )
    }

    //modified_pages.splice(modified_pages, 1)
    const getTextAlignment = (text_align: string) => {
      if (text_align == 'C') {
        return 'center'
      }
      if (text_align == 'R') {
        return 'right'
      }
      if (text_align == 'L') {
        return 'left'
      }
      return 'left'
    }
    return (
      <div>
        <div className="note-mobile-book" id="note-mobile-book">
          {/*
           *<Lightbox
           *  open={open}
           *  close={() => setOpen(false)}
           *  slides={slides}
           *  render={{
           *    slide: (slide: any) =>
           *      slide.type === 'custom-slide' ? (
           *        <BookMobileLightBoxSlide
           *          slide={slide}
           *          pages_predefined_texts={pages_predefined_texts}
           *          pages_dedication_texts={pages_dedication_texts}
           *          inputDedication={inputDedication}
           *          imageWidth={imageWidth}
           *        />
           *      ) : undefined,
           *  }}
           */}

          <div className="relative start-cover" id="page-0">
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '0')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '0',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) /
                          pt2px(dimensions.width) <
                        10
                          ? 12
                          : (imageWidth * item.font_size) /
                            pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      whiteSpace: 'pre-wrap',
                      left: item.X_coord_percent * 2 + '%',
                      color: item.color,
                      fontFamily: item.font_face + ',sans-serif',
                    }}
                    dangerouslySetInnerHTML={{__html: item.text}}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover border-[1.5px] border-primary rounded-md p-1"
              width={300}
              height={300}
              priority={true}
              onLoad={handleImageLoad}
              src={formatImageUrl(cover_pages[0])}
            />
          </div>
          {modified_pages?.reverse().map((page: any, index: number) => {
            if (index == 0) {
              return <></>
            }
            return (
              <div className="relative" id={`page-${index}`} key={index}>
                <Image
                  key={index}
                  onLoad={handleImageLoad}
                  className={`block w-full mob-book-image img-${index} border-[1.5px] border-primary rounded-md p-1`}
                  height={300}
                  width={300}
                  alt="img"
                  src={formatImageUrl(page)}
                />

                {pages_dedication_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.dedication_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_dedication_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.mob-book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          style={{
                            fontSize:
                              (imageWidth * item.font_size) /
                                pt2px(dimensions.width) <
                              10
                                ? 12
                                : (imageWidth * item.font_size) /
                                  pt2px(dimensions.width),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            whiteSpace: 'pre-wrap',
                            textAlign: getTextAlignment(item.text_align),
                            lineHeight: item.line_height,
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face + ',sans-serif',
                          }}>
                          {inputDedication.replace(
                            '{basmti}',
                            name ?? product.replace_name,
                          )}
                        </div>
                      )
                    } else {
                      return <></>
                    }
                  })}
                {pages_predefined_texts
                  .filter((x: any) => x.page == index.toString())[0]
                  ?.predefined_texts?.map((item: any, idx: number) => {
                    let dimensions = JSON.parse(
                      pages_predefined_texts.filter(
                        (x: any) => x.page == index.toString(),
                      )[0]['dimensions'],
                    )
                    let book_img = document.querySelector('.mob-book-image')
                    if (item) {
                      return (
                        <div
                          className="texts absolute"
                          key={idx}
                          style={{
                            //fontSize:
                            //(imageWidth * item.font_size) /
                            //pt2px(dimensions.width) <
                            //10
                            //? 12
                            //: (imageWidth * item.font_size) /
                            //pt2px(dimensions.width),

                            fontSize:
                              (imageWidth * item.font_size) /
                              pt2px(dimensions.width),
                            width:
                              (imageWidth * item.max_width) /
                              pt2px(dimensions.width),
                            top: item.Y_coord_percent + '%',
                            textAlign: getTextAlignment(item.text_align),
                            lineHeight: item.line_height,
                            whiteSpace: 'pre-wrap',
                            color: item.color,
                            left: item.X_coord_percent + '%',
                            fontFamily: item.font_face + ',sans-serif',
                          }}
                          dangerouslySetInnerHTML={{__html: item.text}}></div>
                      )
                    } else {
                      return <></>
                    }
                  })}
              </div>
            )
          })}

          <div className="relative" id={`page-${modified_pages.length + 1}`}>
            {cover_pages_predefined_texts
              ?.filter((x: any) => x.page == '1')[0]
              ?.predefined_texts?.map((item: any, idx: number) => {
                let dimensions = JSON.parse(
                  cover_pages_predefined_texts.filter(
                    (x: any) => x.page == '1',
                  )[0]['dimensions'],
                )
                return (
                  <div
                    className="texts absolute"
                    key={idx}
                    id={item.X_coord_percent}
                    style={{
                      fontSize:
                        (imageWidth * item.font_size) /
                          pt2px(dimensions.width) <
                        10
                          ? 12
                          : (imageWidth * item.font_size) /
                            pt2px(dimensions.width),
                      textAlign: getTextAlignment(item.text_align),
                      width:
                        (imageWidth * item.max_width) / pt2px(dimensions.width),
                      top: item.Y_coord_percent + '%',
                      lineHeight: item.line_height,
                      left: item.X_coord_percent * 2 + '%',
                      whiteSpace: 'pre-wrap',
                      color: item.color,
                      fontFamily: item.font_face + ',sans-serif',
                    }}
                    dangerouslySetInnerHTML={{__html: item.text}}></div>
                )
              })}
            <Image
              alt="cover"
              className="w-full h-full object-cover border-[1.5px] border-primary rounded-md p-1"
              width={700}
              height={700}
              priority={true}
              onLoad={handleImageLoad}
              src={formatImageUrl(cover_pages[1])}
            />
          </div>
        </div>

        <div className="flex lg:hidden justify-center">
          <div className="flex controls bg-[#DDE2E8] items-center justify-center mt-10 py-2 px-2 gap-2 rounded-md">
            <div className="flex items-center gap-2">
              <a
                href="#"
                className={`${
                  page == 0 ? 'opacity-40 cursor-not-allowed' : ''
                } bg-success-500 flex justify-center items-center rounded-full py-2 px-[0.6rem] w-[32px] h-[32px] personalize-control`}
                onClick={e => {
                  e.preventDefault()
                  console.log('scrolling to beginning')
                  scrollToStart()
                }}>
                <svg
                  width="24"
                  height="20"
                  viewBox="0 0 16 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.07812 12.4271L14.4666 7.0387L9.07812 1.65027"
                    stroke="#00214D"
                    strokeWidth="2.26625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M1.53906 12.4271L6.92749 7.0387L1.53906 1.65027"
                    stroke="#00214D"
                    strokeWidth="2.26625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
              <a
                href="#"
                className={`${
                  page == 0 ? 'opacity-40 cursor-not-allowed' : ''
                } bg-success-500 flex justify-center items-center rounded-full py-2 px-[0.6rem] w-[32px] h-[32px] personalize-control`}
                onClick={e => {
                  e.preventDefault()
                  console.log('scrolling to next page')
                  scrollToNextSnap()
                }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none">
                  <path
                    d="M1.30469 12.427L6.69311 7.03858L1.30469 1.65015"
                    stroke="#00214D"
                    strokeWidth="2.26625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
            <span className="text-primary text-xs">لتصفح القصة</span>
            <div className="flex items-center gap-2">
              <a
                href="#"
                className={`${
                  -1 * Math.floor(scrollPosition / mobile_book_width) >=
                  modified_pages.length + 1
                    ? 'opacity-40 cursor-not-allowed'
                    : ''
                } bg-success-500 flex justify-center items-center rounded-full py-2 px-[0.6rem] w-[32px] h-[32px] personalize-control`}
                onClick={e => {
                  e.preventDefault()

                  console.log('scrolling to prev page')
                  scrollToPrevSnap()
                }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none">
                  <path
                    d="M6.69531 12.427L1.30689 7.03858L6.69531 1.65015"
                    stroke="#00214D"
                    strokeWidth="2.26625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
              <a
                href="#"
                className={`${
                  -1 * Math.floor(scrollPosition / mobile_book_width) >=
                  modified_pages.length + 1
                    ? 'opacity-40 cursor-not-allowed'
                    : ''
                } bg-success-500 flex justify-center items-center rounded-full py-2 px-[0.6rem] w-[32px] h-[32px] personalize-control`}
                onClick={e => {
                  e.preventDefault()
                  console.log('scrolling to end page')
                  scrollToEnd()
                }}>
                <svg
                  width="24"
                  height="20"
                  viewBox="0 0 16 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.92188 12.4271L1.53345 7.0387L6.92188 1.65027"
                    stroke="#00214D"
                    strokeWidth="2.26625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.4609 12.4271L9.07251 7.0387L14.4609 1.65027"
                    stroke="#00214D"
                    strokeWidth="2.26625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        {/*
         *        <div className="flex justify-center">
         *          <div className="flex controls bg-[#DDE2E8] items-center justify-center mt-10 py-2 px-3 gap-4 rounded-md">
         *            <a
         *              href="#"
         *              className={`${page == 0 ? 'opacity-40 cursor-not-allowed' : ''
         *                } bg-success-500 flex justify-center items-center rounded-md py-2 px-4`}
         *              onClick={e => {
         *                e.preventDefault()
         *                scrollToNextSnap()
         *              }}>
         *              <svg
         *                xmlns="http://www.w3.org/2000/svg"
         *                width="14"
         *                height="29"
         *                viewBox="0 0 14 29"
         *                fill="none">
         *                <path
         *                  d="M0.00801373 2.6508C0.00652313 2.91383 0.055933 3.17457 0.153409 3.41807C0.250885 3.66158 0.394508 3.88305 0.576047 4.0698L9.56665 13.2233C9.75024 13.4091 9.89596 13.6302 9.9954 13.8737C10.0948 14.1173 10.146 14.3785 10.146 14.6423C10.146 14.9062 10.0948 15.1674 9.9954 15.4109C9.89596 15.6545 9.75024 15.8755 9.56665 16.0613L0.576047 25.2149C0.20721 25.5912 0 26.1016 0 26.6339C0 27.1661 0.20721 27.6765 0.576047 28.0529C0.944884 28.4292 1.44514 28.6406 1.96675 28.6406C2.22503 28.6406 2.48078 28.5887 2.71939 28.4879C2.95801 28.387 3.17482 28.2392 3.35745 28.0529L12.3285 18.8793C13.401 17.7403 14 16.2219 14 14.6423C14 13.0627 13.401 11.5444 12.3285 10.4053L3.35745 1.23181C3.17536 1.04448 2.95872 0.895794 2.72003 0.794329C2.48134 0.692863 2.22533 0.640625 1.96675 0.640625C1.70817 0.640625 1.45216 0.692863 1.21347 0.794329C0.974775 0.895794 0.758137 1.04448 0.576047 1.23181C0.394508 1.41855 0.250885 1.64003 0.153409 1.88353C0.055933 2.12703 0.00652313 2.38777 0.00801373 2.6508Z"
         *                  fill="#00214D"
         *                />
         *              </svg>
         *              <span className="text-primary font-semibold mr-3 mt-1 text-sm">
         *                أضغط هنا
         *              </span>
         *            </a>
         *            <span className="h-10 w-[.2rem] bg-[#A1B0BB]"></span>
         *            <a
         *              href="#"
         *              className={`${-1 * Math.floor(scrollPosition / mobile_book_width) >=
         *                  modified_pages.length + 1
         *                  ? 'opacity-40 cursor-not-allowed'
         *                  : ''
         *                } bg-success-500 flex justify-center items-center rounded-md py-2 px-4 text-sm`}
         *              onClick={e => {
         *                e.preventDefault()
         *
         *                scrollToPrevSnap()
         *              }}>
         *              <span className="text-primary font-semibold ml-3 mt-1">
         *                أضغط هنا
         *              </span>
         *              <svg
         *                xmlns="http://www.w3.org/2000/svg"
         *                width="14"
         *                height="29"
         *                viewBox="0 0 14 29"
         *                fill="none">
         *                <path
         *                  d="M13.992 2.6508C13.9935 2.91383 13.9441 3.17457 13.8466 3.41807C13.7491 3.66158 13.6055 3.88305 13.424 4.0698L4.43335 13.2233C4.24976 13.4091 4.10404 13.6302 4.0046 13.8737C3.90516 14.1173 3.85396 14.3785 3.85396 14.6423C3.85396 14.9062 3.90516 15.1674 4.0046 15.4109C4.10404 15.6545 4.24976 15.8755 4.43335 16.0613L13.424 25.2149C13.7928 25.5912 14 26.1016 14 26.6339C14 27.1661 13.7928 27.6765 13.424 28.0529C13.0551 28.4292 12.5549 28.6406 12.0332 28.6406C11.775 28.6406 11.5192 28.5887 11.2806 28.4879C11.042 28.387 10.8252 28.2392 10.6425 28.0529L1.67153 18.8793C0.598994 17.7403 0 16.2219 0 14.6423C0 13.0627 0.598994 11.5444 1.67153 10.4053L10.6425 1.23181C10.8246 1.04448 11.0413 0.895794 11.28 0.794329C11.5187 0.692863 11.7747 0.640625 12.0332 0.640625C12.2918 0.640625 12.5478 0.692863 12.7865 0.794329C13.0252 0.895794 13.2419 1.04448 13.424 1.23181C13.6055 1.41855 13.7491 1.64003 13.8466 1.88353C13.9441 2.12703 13.9935 2.38777 13.992 2.6508Z"
         *                  fill="#00214D"
         *                />
         *              </svg>
         *            </a>
         *          </div>
         *        </div>
         */}
      </div>
    )
  }
  return <></>
}